import {
  SearchProcedureParams,
  SearchProcedureResponse
} from "domain/usecases/private/guide-flow/medical-guide/search-procedure";
import {makeSearchProcedure} from "main/factories/usecases/private/guide-flow/remote-medical-guide/search-procedure-factory";

export async function searchProcedure(params: SearchProcedureParams): Promise<SearchProcedureResponse> {
  return await makeSearchProcedure().get(params);
}
